import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: 0
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.count = action.payload;
    },
    incrementNotifications: (state) => {
      state.count += 1;
    },
    decrementNotifications: (state) => {
      state.count = Math.max(0, state.count - 1);
    }
  }
});

export const { setNotifications, incrementNotifications, decrementNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer; 